import { TransportStep } from './enums/transport-step.enum';

export class TunnelStep {
  public title!: string;
  public url!: string;
  public idCypress?: string;
  public notClickable: boolean;
  public hasPreviousStep: boolean;
  public hasNextStep: boolean;
  public invalid: boolean;
  public step!: TransportStep;
  public icon?: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.notClickable = data.notClickable ?? true;
    this.hasPreviousStep = data.hasPreviousStep ?? true;
    this.hasNextStep = data.hasNextStep ?? true;
    this.invalid = data.invalid ?? false;
  }
}
